import styled from 'styled-components'
import { useState, useEffect, useRef} from 'react'
import ImageGrid from './ImageGrid'
import React from 'react'

const ImgGallery = () => {

    const [offSetY, setOffSetY] = useState(0)
    const [category, setCategory] = useState("handrails")
    const dropRef = useRef(null)
    const [products,setProducts] = useState([])


    const viewImages = (event) => {
        setCategory(event.target.id);
    }

    const showDrop = () => {
        dropRef.current.classList.toggle("block");
    }


    const handleParallax = () => {
        setOffSetY(window.pageYOffset)
    }

    useEffect(() => {

        fetch(process.env.REACT_APP_BACKEND_URL)
        .then((response) => {return response.json()})
        .then((result) => {setProducts(result)})

        window.addEventListener('scroll', handleParallax)
        return () => {
            window.removeEventListener('scroll',handleParallax)
        }
    }, [])

    return (
        <Wrapper id="categories">
            <h1
            style = {
                { transform: `translateY(-${offSetY * 0.15}px)`}
            }
            >
                Gallery
            </h1>
            <nav>
                <div className="nav-wrapper">
                    <button className="category">
                        Categories
                    </button>
                        <button
                        className="drop-button"
                        onClick={showDrop}
                        >
                            <i className="fa fa-caret-down"></i>
                        </button>
                </div>
                <div
                    className="drop-content"
                    ref={dropRef}
                    onClick={showDrop}
                >
                    <button
                    id='handrails'
                    onClick={viewImages}
                    >
                        Hand Rails
                    </button>
                    <button
                    id='gates'
                    onClick={viewImages}
                    >
                        Gates
                    </button>
                    <button
                    id='balcony'
                    onClick={viewImages}
                    >
                        Balcony
                    </button>
                    <button
                    id='swing'
                    onClick={viewImages}
                    >
                        Swing
                    </button>
                    <button
                    id='safetygrills'
                    onClick={viewImages}
                    >
                        Safety Grills
                    </button>
                    <button
                    id='spiralsteps'
                    onClick={viewImages}
                    >
                        Spiral Steps
                    </button>
                    <button
                    id='glasshandrails'
                    onClick={viewImages}
                    >
                        Glass Hand Rails
                    </button>
                    <button
                    id='sssteps'
                    onClick={viewImages}
                    >
                        SS Steps
                    </button>
                </div>
            </nav>
            <ImageGrid category={category} products={products}/>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    h1 {
        font-weight: 700;
        text-align: center;
        margin-top: 3rem;
        font-size: 2rem;
    }
    nav {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
    }
    .drop-button {
        background: #000;
    }
    .drop-content {
        display: none;
        background: #252525;
        min-width: 165px;
        z-index: 5;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .drop-content button:hover {
        background: #000;
    }
    .drop-content button {
        display: block;
        background: transparent;
        width: 100%;
    }
    button {
        font-weight: 700;
        font-size: 1rem;
        background: #252525;
        color: #fff;
        padding: 1rem;
    }
    .block {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
    }
    .category {
        cursor: alias;
    }
`

export default React.memo(ImgGallery)
